var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-success"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"top"},[_c('img',{attrs:{"src":require("../assets/success.png"),"alt":""}}),_c('h2',[_vm._v("支付成功！")]),_c('h5',[_vm._v("您已支付成功，祝您旅途愉快！")])])])])
}]

export { render, staticRenderFns }